import { categories } from "@/mocks/categories";
import { posts } from "@/mocks/posts";
import type { Category, Post } from "@/types/content";

export const allPosts: Post[] = posts as Post[];
export const allCategories: Category[] = categories as Category[];

export function getCategoryBySlug(slug: string): Category | undefined {
  return allCategories.find((item) => item.slug === slug);
}

export function getPostById(id: string): Post | undefined {
  return allPosts.find((item) => item.id === id);
}

export function getPostsByCategory(slug: string): Post[] {
  return allPosts.filter((item) => item.categorySlug === slug);
}

export function getCategoryName(slug: string): string {
  return getCategoryBySlug(slug)?.name ?? "内容";
}

export function getFeaturedPosts(): Post[] {
  return allPosts.filter((item) => item.featured);
}

export function getHotPosts(limit = 5): Post[] {
  return [...allPosts].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatestPosts(limit = 6): Post[] {
  return [...allPosts]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, limit);
}

export function getRelatedPosts(post: Post, limit = 3): Post[] {
  const sameCategory = allPosts.filter(
    (item) => item.categorySlug === post.categorySlug && item.id !== post.id,
  );
  if (sameCategory.length >= limit) return sameCategory.slice(0, limit);
  const others = allPosts.filter(
    (item) => item.categorySlug !== post.categorySlug && item.id !== post.id,
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function searchPosts(keyword: string): Post[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return allPosts.filter((post) => {
    const haystack = [
      post.title,
      post.excerpt,
      post.tags.join(" "),
      getCategoryName(post.categorySlug),
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(key);
  });
}

export function formatDate(date: string): string {
  const [year, month, day] = date.split("-");
  if (!year || !month || !day) return date;
  return `${year} 年 ${Number(month)} 月 ${Number(day)} 日`;
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)} 万`;
  }
  return `${views}`;
}